import React, { Component } from "react";
import ContentBody from "../components/ContentBody";
import MoreGames from "../components/MoreGames";
import CustomerRatings from "../components/CustomerRatings";
import NewProductItem from "../components/NewProductItem";
import SocialLink from "../components/SocialLink";
import Language from "../utils/Language";
import styles from "./PageHome.module.css";

class PageHome extends Component {
  render() {
    const games = require("../products/games.json");
    const tools = require("../products/dev_tools.json");

    const stats = [
      { value: games.length, label: Language.GetString("stats_games") },
      { value: tools.length, label: Language.GetString("stats_tools") },
      { value: "100%", label: Language.GetString("stats_free") }
    ];

    return (
      <div>
        <NewProductItem />
        <ContentBody noTopPadding>
          <section className={styles.Stats}>
            {stats.map((s, i) => (
              <div key={i} className={styles.Stat}>
                <div className={styles.StatValue}>{s.value}</div>
                <div className={styles.StatLabel}>{s.label}</div>
              </div>
            ))}
          </section>

          <MoreGames />
          <SocialLink />
          <CustomerRatings />
        </ContentBody>
      </div>
    );
  }
}

export default PageHome;
